function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import ResizeDetector from "../../../helpers/ResizeDetector";
import isNotEmpty from "../../../utils/isNotEmpty";
import ProductCardsSliderOrgContext from "../../organisms/ProductCardsSliderOrg/ProductCardsSliderOrgContext";
import { backgroundColor } from "./AdvancedProductCardMol.settings";
import { BoxLink, Card, DefaultContainer, DesktopDetailedContainer, StyledFooter, StyledMainContent } from "./AdvancedProductCardMol.styled";
function AdvancedProductCardMol(_ref) {
  var backgroundImage = _ref.backgroundImage,
    logo = _ref.logo,
    textBox = _ref.textBox,
    label = _ref.label,
    title = _ref.title,
    description = _ref.description,
    link = _ref.link,
    parameters = _ref.parameters,
    price = _ref.price,
    renewPrice = _ref.renewPrice,
    priceText = _ref.priceText,
    button = _ref.button,
    buttonColor = _ref.buttonColor,
    buttonVariant = _ref.buttonVariant,
    onClick = _ref.onClick;
  var mainContentRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasHover = _useState2[0],
    setHasHover = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasFocus = _useState4[0],
    setHasFocus = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    mainContentHeight = _useState6[0],
    setMainContentHeight = _useState6[1];
  var _useContext = useContext(ProductCardsSliderOrgContext),
    advancedCardContent = _useContext.advancedCardContent;
  var mainContentProps = {
    backgroundImage: backgroundImage,
    logo: logo,
    textBox: textBox,
    label: label,
    title: title,
    link: link,
    description: description
  };
  var footerProps = {
    parameters: parameters,
    price: price,
    renewPrice: renewPrice,
    priceText: priceText,
    button: button,
    buttonColor: buttonColor,
    buttonVariant: buttonVariant,
    link: link
  };
  var hasHoverState = hasHover && !!parameters && !priceText;
  var setMainContentHeightValue = function setMainContentHeightValue() {
    var mainContentRefCurrent = mainContentRef.current;
    if (mainContentRefCurrent) {
      return setMainContentHeight(mainContentRefCurrent.offsetHeight);
    }
    return setMainContentHeight(0);
  };
  var handleWindowResize = useCallback(function () {
    setMainContentHeightValue();
  }, []);
  var handleCardMouseEnter = function handleCardMouseEnter() {
    return setHasHover(true);
  };
  var handleCardMouseLeave = function handleCardMouseLeave() {
    return setHasHover(false);
  };
  var handleCardFocus = function handleCardFocus() {
    setHasFocus(true);
  };
  var handleCardBlur = function handleCardBlur() {
    setHasFocus(false);
  };
  useEffect(function () {
    setMainContentHeightValue();
    setTimeout(setMainContentHeightValue, 100);
    window.addEventListener("resize", handleWindowResize);
    return function () {
      return window.removeEventListener("resize", handleWindowResize);
    };
  }, [handleWindowResize]);
  var boxLink = /*#__PURE__*/React.createElement(BoxLink, {
    to: link.to,
    href: link.href,
    title: link.title,
    openInNewTab: link.openInNewTab,
    onClick: link.onClick,
    rel: link.rel
  }, link.text);
  return /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColor
  }, /*#__PURE__*/React.createElement(Card, {
    onMouseEnter: handleCardMouseEnter,
    onMouseLeave: handleCardMouseLeave,
    onFocus: handleCardFocus,
    onBlur: handleCardBlur,
    "data-test-id": "advanced-product-card",
    onClick: onClick
  }, /*#__PURE__*/React.createElement(DefaultContainer, {
    onLoad: setMainContentHeightValue,
    $isHidden: hasHoverState
  }, /*#__PURE__*/React.createElement(ResizeDetector, {
    setHeight: advancedCardContent.setMaxHeight
  }, /*#__PURE__*/React.createElement(StyledMainContent, _extends({
    $minHeight: advancedCardContent.maxHeight
  }, mainContentProps, {
    hasHover: hasHover,
    ref: mainContentRef
  }))), /*#__PURE__*/React.createElement(StyledFooter, footerProps), boxLink), isNotEmpty(parameters) ? /*#__PURE__*/React.createElement(DesktopDetailedContainer, {
    $isVisible: hasHoverState || hasFocus
  }, /*#__PURE__*/React.createElement(StyledMainContent, _extends({
    $minHeight: mainContentHeight
  }, mainContentProps)), /*#__PURE__*/React.createElement(StyledFooter, _extends({}, footerProps, {
    isDetailedView: true,
    $isDetailedView: true
  })), boxLink) : null));
}
export default AdvancedProductCardMol;